import ShipmentIcon from 'components/icons/ShipmentIcon';
import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
    padding-right: 40px;
`;

export const StyledShipmentIconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: var(--brand-1);
    border-radius: 8px;
    width: 32px;
    height: 32px;
`;

export const StyledShipmentIcon = styled(ShipmentIcon)`
    font-size: 20px;
    color: var(--brand-6);
`;

export const StyledFormSectionHeader = styled.header`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledFormSectionHeaderLabelWrapper = styled.h2`
    display: inline;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 0;
`;

export const ErrorDiv = styled.div`
    color: var(--error-normal);
    font-weight: 400;
    font-size: 14px;
`;

export const StyledReadonlySectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledFormSectionContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledCustomerAutocompleteLabelWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 5px 12px;
`;

export const StyledCustomerAutocompleteLabel = styled.span`
    flex-grow: 1;
`;
